import React, { useState, useEffect } from "react";
import logger from "./../../logger";
import axios from "axios";
import { Link } from "react-router-dom";
import Grid from "@material-ui/core/Grid";

import { setUserSession } from "../.././Utils/Common";
import Constants from "./../../Utils/Constants";
import AuthService from "./../../services/AuthService";

import HomeLogo from "./../../Common/HomeLogo";
import HomeFooter from "./../../Common/HomeFooter";
import FeatureGrid from "./../../Common/FeatureGrid";

import "./index.scoped.css";

function Login(props) {
  const username = useFormInput("");
  const password = useFormInput("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [content, setContent] = useState()

  useEffect(() => {
    let url = window.location.href.split('/')[2]
    axios.get(Constants.partnersApiPath + `?domain=${url}`)
    .then(r => setContent(r.data.data))
    .catch(e => console.error(e))
  }, [])

  const handleLogin = async () => {
    setError(null);
    setLoading(true);
    try {
      const { data: loginData } = await AuthService.login(username.value, password.value);
      const { access_token, refresh_token, expires_in } = loginData.token ?? loginData;

      if (!access_token || !access_token.includes('.')) {
        setError("Login failed: invalid token received. Please try again.");
        return;
      }

      const { data: userData } = await axios.get(Constants.userApiPath, {
        headers: { Authorization: `Bearer ${access_token}` },
      });

      setUserSession(access_token, refresh_token, expires_in, userData.data);
      Constants.navigate(Constants.dashboard);
    } catch (error) {
      const status = error?.response?.status;
      if (status >= 500) {
        setError("Something went wrong, please try later.");
      } else if (error?.response?.data?.message) {
        setError(error.response.data.message);
      } else {
        setError("Please check your username and password");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{}}>
      <div>
        <Grid container spacing={0}>
          <FeatureGrid data={content} />
          <Grid item md={6} xs={12} className="formcontent">
            <div className="loginMain">
              <HomeLogo data={content} />
              <div className="login-wrap">
                <h3 className="login-wrap_heading mb-30">login</h3>
                <div className="form-group" style={{ width: "100%" }}>
                  <input
                    placeholder="Enter Email"
                    className="login-textbx"
                    {...username}
                    type="text"
                    id="email"
                    name="email"
                    value={username.value}
                  />
                </div>
                <div className="form-group" style={{ width: "100%" }}>
                  <input
                    placeholder="Enter Password"
                    className="login-textbx"
                    {...password}
                    type={showPassword ? "text" : "password"}
                    value={password.value}
                    id="password"
                    name="password"
                    style={{ paddingRight: "46px" }}
                    onKeyPress={(event) => {
                      if (event.key == "Enter") {
                        handleLogin();
                      }
                    }}
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(v => !v)}
                    style={{
                      position: "absolute",
                      right: "12px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      padding: "0",
                      color: "#777",
                      lineHeight: 1,
                    }}
                    tabIndex={-1}
                    aria-label={showPassword ? "Hide password" : "Show password"}
                  >
                    {showPassword ? (
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
                        <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
                        <line x1="1" y1="1" x2="23" y2="23"/>
                      </svg>
                    ) : (
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                        <circle cx="12" cy="12" r="3"/>
                      </svg>
                    )}
                  </button>
                </div>
                <div>
                  {error && (
                    <>
                      <small style={{ color: "red" }}>{error}</small>
                      <br />
                    </>
                  )}
                </div>
                <div className="action-link">
                  <Link 
                    className="forgot-link"
                    to={Constants.forgotpassword}
                    style={{ textDecoration: "underline" }}
                  >
                    Forgot Password?
                  </Link>

                  <Link 
                    className="forgot-link"
                    to={Constants.signup}
                    style={{ textDecoration: "underline" }}
                  >
                    Don't have an account? Create one.
                  </Link>

                  <input
                    className="login-btn c-button"
                    type="button"
                    value="SIGN IN"
                    onClick={handleLogin}
                    disabled={loading}
                  />
                </div>
              </div>
              <HomeFooter />
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

const useFormInput = (initialValue) => {
  const [value, setValue] = useState(initialValue);

  const handleChange = (e) => {
    setValue(e.target.value);
  };
  return {
    value,
    onChange: handleChange,
  };
};

export default Login;
